// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"847":"ad62dc72","852":"155b5f6c","943":"3d6f2717","991":"3d6f2717"}[chunkId] + ".chunk.css";
};